import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { BaseFormComponent } from "../../../../shared/components/base-form/base-form.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { INotaAuditoriaExecucaoModel } from "../../../../models/nota-auditoria-execucao.model";
import { EnumRecursoPerfil } from "../../../../models/enum/recurso-perfil.enum";
import { EnumAcaoRecurso } from "../../../../models/enum/acao-recurso.enum";
import { AuthService } from "../../../../services/auth.service";
import { NotaAuditoriaExecucaoService } from "../../../../services/nota-auditoria-execucao.service";
import Swal from "sweetalert2";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { ModalIncluirNotaExecucaoComponent } from "./modal-incluir-nota/modal-incluir-nota-execucao.component";
import { SharedService } from "../../../../services/shared.service";
import {
  ModalResponderNotaAuditoriaExecucaoComponent
} from "./modal-responder-nota/modal-responder-nota-auditoria-execucao.componet";
import {
  ModalAvaliarProrrogacaoComponent
} from "../../../../shared/components/aba-solicitacao-tecnica/modal-avaliar-prorrogacao/modal-avaliar-prorrogacao.component";
import {
  ModalAvaliarProrrogacaoNotaAuditoriaComponent
} from "./modal-avaliar-prorrogacao-nota-auditoria/modal-avaliar-prorrogacao-nota-auditoria.component";
import {
  ModalJustificativaComponent
} from "../../../../shared/components/modal-justificativa/modal-justificativa.component";
import { IItemSolicitacaoTecnicaModel } from "../../../../models/item-solicitacao-tecnica.model";
import {
  ModalResponderItemNotaAuditoriaExecucaoComponent
} from "./modal-responder-item-nota/modal-responder-item-nota-auditoria-execucao.componet";
import { INotaItemAuditoriaExecucaoModel } from "../../../../models/nota-item-auditoria-execucao.model";

@Component({
  selector: 'app-osa-execucao-nota-auditoria',
  templateUrl: './osa-execucao-aba-nota-auditoria.component.html',
  styleUrls: ['./osa-execucao-aba-nota-auditoria.component.scss']
})

export class OsaExecucaoAbaNotaAuditoriaComponent extends BaseFormComponent implements OnInit {

  public displayedColumns: string[] = [
    "selecao",
    "numero",
    "assunto",
    "prazo",
    "ug",
    "responsavel",
    "status",
    "resposta",
  ];
  public dataSource = new MatTableDataSource<INotaAuditoriaExecucaoModel>([]);
  public selectedModel: INotaAuditoriaExecucaoModel;
  public semDados = true;
  public permitido: boolean = false;
  public podeCancelarSolicitacao: boolean = false;
  public podeImprimir: boolean = false;
  public podeCancelarItem: boolean = false;
  public podeRespSolExterna: boolean = false;
  public podeApreciarProrrogacao: boolean = false;
  public podeHabilitarResposta: boolean = false;
  public podeExecutar: boolean = false;
  public podeAvaliarResposta: boolean = false;
  dataAtual = new Date();
  @Input() public visualizar: boolean = false;
  public dataVencida: boolean;
  public numeroOsa: string;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("maxLengthEditor") private angularEditor: any;

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    public authService: AuthService,
    public notaAuditoriaService: NotaAuditoriaExecucaoService,
    private sharedService: SharedService,
    localeService: BsLocaleService,
    public matDialog: MatDialog,
  ) {
    super(route, toastr, router, localeService, matDialog);
    this.titulo = 'Executar';
  }

  ngOnInit(): void {
    this.setarPermissoes();
    if (this.visualizar) {
      this.titulo = 'Visualizar';
    } else {
      this.titulo = 'Executar';
    }
    this.obter();
  }

  private setarPermissoes(): void {
    this.podeExecutar = this.authService.possuiPermissao(EnumRecursoPerfil.AuditoriaExecucao, EnumAcaoRecurso.Executar);
    this.podeImprimir = this.authService.possuiPermissao(EnumRecursoPerfil.AuditoriaExecucao, EnumAcaoRecurso.Imprimir);
  }

  ngAfterViewInit() {
    function maxLengthAngularEditor(e: any) {
      var element = e.target as HTMLTextAreaElement;
      let permitirTeclas =
        e.key !== "Backspace" &&
        e.key !== "ArrowLeft" &&
        e.key !== "ArrowRight";
      if (element.innerHTML.length === 2000 && permitirTeclas) {
        e.preventDefault();
      }
    }

    this.angularEditor?.textArea?.nativeElement.addEventListener(
      "keydown",
      maxLengthAngularEditor,
      false
    );
  }

  public obter() {
    this.notaAuditoriaService
      .obter(this.id)
      .then((res) => {


        if (res.dados) {
          this.dataSource = new MatTableDataSource<INotaAuditoriaExecucaoModel>(res.dados);

          this.semDados = this.dataSource.filteredData.length === 0;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
          this.selectedModel = null
        }
      })
      .catch((err) => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text: err.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      });
  }

  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "prazo":
        return item?.prazo;
      case "status":
        return item?.status?.descricao;
      case "ug":
        return item?.unidadeGestoraSigla;
      case "assunto":
        return item?.assunto;
      case "responsavel":
        return item?.nomeResponsavel;
      default:
        return item[property];
    }
  };


  public modalVisualizarItem(element?: INotaAuditoriaExecucaoModel) {
    const dataFimRealizacao = this.sharedService.getDataFimRealizacao();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-component-resposta-list-init";
    dialogConfig.width = "60%";
    dialogConfig.height = "90vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Visualizar Resposta Nota de Auditoria",
      id: element?.id,
      avaliar: false,
      solicitacaoTecnicaId: element.id,
      responder: false,
      numeroNotaAuditoria: element.numero,
      visualizar: true,
      documentoAssociado: this.sharedService.getNumeroOsa(),
      resposavel: element.nomeResponsavel,
      element,
      dataLimite:dataFimRealizacao
        ? new Date(dataFimRealizacao)
        : new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate() + 30)

    };
    const modal = this.matDialog.open(
      ModalResponderNotaAuditoriaExecucaoComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((data) => {
      this.obter();
    });
  }
  incluirNotaAuditoria(titulo: string, visualizar: boolean, model?: INotaAuditoriaExecucaoModel): void {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-component-nota-auditoria-execucao';
    dialogConfig.width = '80%';
    dialogConfig.height = '90%';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo,
      id: model?.id, // ID para buscar os dados
      status: model?.status,
      visualizar,
      acaoCancelarItem: false,
      osaExecucaoId: this.id,
      documentoAssociado: this.sharedService.getNumeroOsa(),
      numeroST: model?.numero,
      dataLimite: this.sharedService.getDataFimRealizacao()
        ? new Date(this.sharedService.getDataFimRealizacao())
        : new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate() + 30)
    };

    const modal = this.matDialog.open(
      ModalIncluirNotaExecucaoComponent,
      dialogConfig
    );

    modal.afterClosed().subscribe((data) => {
      if (data) {
        // Fazer algo com os dados retornados se necessário
      }
      this.obter();
    });
  }

  cancelarNotaAuditoria(id: number): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-component';
    dialogConfig.width = '45vw';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = false;
    dialogConfig.data = {
    }
    const modal = this.matDialog.open(ModalJustificativaComponent, dialogConfig);
    modal.afterClosed().subscribe(justificativa => {
      if (justificativa) {

        const responsavelId = this.authService.usuario.id;

        this.notaAuditoriaService.cancelarNotaAuditoriaExecucao(id, justificativa, responsavelId)
          .then((res) => {
            if (res.sucesso) {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          }).catch((err) => {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            text: err.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }).finally(() => {
          this.obter()
        });
      }
    });
  }

  public excluir(id: number) {
    Swal.fire({
      title: "Excluir Registro",
      text: "Tem certeza que deseja excluir esse Registro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {
      if (res.value) {
        this.notaAuditoriaService
          .excluir(id)
          .then((res) => {
            if (res.sucesso) {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          })
          .catch((err) => {
            Swal.fire({
              toast: true,
              position: "top-end",
              text: err.mensagem.descricao,
              icon: "error",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
            });
          }).finally(() => {
            this.obter()
          }
        );
      }
    });
  }

  imprimir(model: INotaAuditoriaExecucaoModel): void {
    this.router.navigateByUrl(`/nota-auditoria-execucao/${model?.id}/imprimir`);
  }


  public responderNotaAuditoria(selectedModel?: INotaAuditoriaExecucaoModel) {
    const dataFimRealizacao = this.sharedService.getDataFimRealizacao();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-component-responder-solicitacao-tecnica';
    dialogConfig.width = '80%';
    dialogConfig.height = '90%';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      responder: true,
      avaliar: false,
      titulo: 'Responder Nota de Auditoria',
      element: selectedModel,
      id: selectedModel?.id,
      status: selectedModel?.status,
      visualizar: true,
      documentoAssociado: this.sharedService.getNumeroOsa(),
      numeroST: selectedModel?.numero,
      dataLimite:dataFimRealizacao
        ? new Date(dataFimRealizacao)
        : new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate() + 30)
    };

    const modal = this.matDialog.open(
      ModalResponderNotaAuditoriaExecucaoComponent,
      dialogConfig
    );

    modal.afterClosed().subscribe((data) => {
      if (data) {
      }
      this.obter()
    });
  }

  cancelarConstacao(titulo: string , model: INotaAuditoriaExecucaoModel): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-component-nota-auditoria-execucao';
    dialogConfig.width = '80%';
    dialogConfig.height = '90%';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo,
      id: model?.id, // ID para buscar os dados
      status: model?.status,
      element: model,
      visualizar: true,
      acaoCancelarItem: true,
      osaExecucaoId: this.id,
      documentoAssociado: this.sharedService.getNumeroOsa(),
      numeroST: model?.numero,
      dataLimite: this.sharedService.getDataFimRealizacao()
        ? new Date(this.sharedService.getDataFimRealizacao())
        : new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate() + 30)
    };
    const modal = this.matDialog.open(
      ModalIncluirNotaExecucaoComponent,
      dialogConfig
    );

    modal.afterClosed().subscribe((data) => {
      if (data) {

      }
      this.obter();
    });

  }

  apreciarProrrogacao(element: INotaAuditoriaExecucaoModel): void {

    console.log(element);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-component";
    dialogConfig.width = "45vw";
    dialogConfig.maxHeight = "85vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      notaAuditoriaExecucaoId: element?.id,
      data:  element?.prorrogarNotaAuditoriaExecucao?.data,
      justificativa: element?.prorrogarNotaAuditoriaExecucao.justificativa,
      dataLimiteProrrogacao: element.DataLimite ? new Date(element.DataLimite) : new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate() + 30)
    };
    const modal = this.matDialog.open(
      ModalAvaliarProrrogacaoNotaAuditoriaComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((data) => {
      this.obter()
    });
  }

  avaliarResposta(selectedModel?: INotaAuditoriaExecucaoModel): void {
    const dataFimRealizacao = this.sharedService.getDataFimRealizacao();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-component-responder-solicitacao-tecnica';
    dialogConfig.width = '80%';
    dialogConfig.height = '90%';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      responder: false,
      avaliar: true,
      titulo: 'Avaliar Nota de Auditoria Execução',
      element: selectedModel,
      id: selectedModel?.id,
      status: selectedModel?.status,
      visualizar: true,
      documentoAssociado: this.sharedService.getNumeroOsa(),
      numeroST: selectedModel?.numero,
      dataLimite:dataFimRealizacao
        ? new Date(dataFimRealizacao)
        : new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate() + 30)
    };

    const modal = this.matDialog.open(
      ModalResponderNotaAuditoriaExecucaoComponent,
      dialogConfig
    );

    modal.afterClosed().subscribe((data) => {
      if (data) {
      }
      this.obter()
    });
  }

  public modalVisualizarResposta(id: number): void {

  }

  formatarTooltipCanc(element: any): string {

    const data = element?.dataHoraCanc
      ? new Date(element.dataHoraCanc).toLocaleDateString('pt-BR')
      : 'Data não informada';

    const nome = element?.responsavelCanc?.nome || 'Usuário desconhecido';
    const comentario = element?.justificativa || 'Sem comentário';

    return `🗓 ${data}\n👤 ${nome}\n💬 ${comentario}`;
  }

  // public selecionar(item: any) {
  //
  //   this.selectedModel =
  //     !this.selectedModel || this.selectedModel.id !== item.id
  //       ? item
  //       : null;
  //
  //   if (this.selectedModel?.status?.codigo === 1 || this.selectedModel?.status?.codigo === 2) {
  //     this.permitido = true;
  //   } else {
  //     this.permitido = false;
  //   }
  //
  //   if (new Date(this.selectedModel?.prazo) <  new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate())) {
  //     this.dataVencida = true;
  //   }
  //   this.podeRespSolExterna = (this.podePlanejar) && (this.selectedModel?.status.codigo == 3 ||
  //     this.selectedModel?.status.codigo == 5 ||
  //     this.selectedModel?.status.codigo == 6 ||
  //     this.selectedModel?.status.codigo == 7 );
  //   this.podeCancelarSolicitacao = (this.podePlanejar) && (this.selectedModel?.status.codigo == 3 || this.selectedModel?.status.codigo == 5 || this.selectedModel?.status.codigo == 7 || this.selectedModel?.status.codigo == 8);
  //   this.podeCancelarItem = (this.podePlanejar) && (this.selectedModel?.status.codigo == 3 || this.selectedModel?.status.codigo == 7 || this.selectedModel?.status.codigo == 8);
  //   this.podeApreciarProrrogacao = (this.podePlanejar) && (this.selectedModel?.status.codigo == 5);
  //   const statusOsaExecucao = this.sharedService.getstatusOsaExecucao();
  //
  //   this.podeHabilitarResposta =
  //     statusOsaExecucao === 1 ||
  //     (
  //       (this.selectedModel?.status.codigo === 3 ||
  //         this.selectedModel?.status.codigo === 7 ||
  //         this.selectedModel?.status.codigo === 8)
  //       && this.dataVencida
  //     );
  //
  //   this.podeAvaliarResposta =
  //     this.podePlanejar &&
  //     (
  //       this.selectedModel?.status.codigo === 3 ||
  //       this.selectedModel?.status.codigo === 5 ||
  //       this.selectedModel?.status.codigo === 7 ||
  //       this.selectedModel?.status.codigo === 8 ||
  //       statusOsaExecucao === 1
  //     );
  // }

  public selecionar(item: any) {

    this.selectedModel =
      !this.selectedModel || this.selectedModel.id !== item.id
        ? item
        : null;

    this.permitido = (this.selectedModel?.status?.codigo === 1 || this.selectedModel?.status?.codigo === 2);

    this.dataVencida = false;

    if (this.selectedModel?.prazo) {
      const hoje = new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate());
      if (new Date(this.selectedModel.prazo) < hoje) {
        this.dataVencida = true;
      }
    }

    const status = this.selectedModel?.status?.codigo;
    const statusOsaExecucao = this.sharedService.getstatusOsaExecucao();

    this.podeRespSolExterna =
      this.podeExecutar &&
      (status === 3 || status === 6 || status === 7 || status === 8);

    this.podeCancelarSolicitacao =
      this.podeExecutar &&
      (status === 3 || status === 7 || status === 8); // removeu o 5


    const statusPodeCancelar = [3, 7, 8];

    this.podeCancelarItem =
      this.podeExecutar &&
      statusPodeCancelar.includes(status);

    this.podeApreciarProrrogacao = this.podeExecutar && status === 5;
    this.podeHabilitarResposta =
      statusOsaExecucao === 1 && (status === 3 || status === 7 || status === 8);


    const podeAvaliarPorStatus = status === 3 || status === 5;

    this.podeAvaliarResposta =
      this.podeExecutar &&
      (
        (statusOsaExecucao === 1 && status !== 7 && status !== 8)
        || podeAvaliarPorStatus
      );
  }

}
